import { SDK_ENUMS, SDK_IDS } from '../utils/constant'
import { store } from '../store/store'

const requestParameters = {

  getMethodParameters ({ methodName, methodParameters }) {
    if (requestParameters[methodName + 'Parameters']) {
      return requestParameters[methodName + 'Parameters']({ methodParameters })
    } else {
      return methodParameters
    }
  },

  bootstrapParameters () {
    let sdkConfigs = {}
    Object.keys(SDK_IDS).forEach((sdkName) => {
      sdkConfigs[sdkName] = { URL: store.getters.sdkJsUrl }
    })
    return sdkConfigs
  },

  initParameters ({ methodParameters }) {
    return methodParameters
  },

  identityLookupParameters ({ methodParameters }) {
    let identityLookupParams = {
      consumerIdentity: {
        identityProvider: SDK_ENUMS.IdentityProvider.src,
        identityType: SDK_ENUMS.IdentityType.emailAddress,
        identityValue: methodParameters
      }
    }
    return identityLookupParams
  },

  initiateIdentityValidationParameters ({ methodParameters }) {
    let initiateIdentityParameters = {
      requestedValidationChannelId: methodParameters
    }
    return initiateIdentityParameters
  },

  completeIdentityValidationParameters ({ methodParameters }) {
    let completeIdValidationParams = {
      validationData: methodParameters
    }
    return completeIdValidationParams
  },

  getSrcProfileParameters () {
    let idTokens = store.getters.idToken
    return { idTokens }
  }
}

export default requestParameters
